import React from 'react';
import * as fileCrud from '../../../../crud/file.crud';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { addDays, addYears } from 'date-fns';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';

class NotifyDocumentPage extends BaseDocument {
    constructor(props) {
        super(props);
        const { fields } = this.props.workflowItem;
        const selectedClause = fields.Type.clauses.find(item => item.display === this.props.notification.replycomment);
        this.state = {
            selectedClause
        }
    }

    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        if (field) {
            if (field === 'replycomment') {
                const { fields } = this.props.workflowItem;
                const selectedClause = fields.Type.clauses.find(item => item.display === value);
                this.setState({ selectedClause: selectedClause });
            }
        }
        this.props.fieldChanged(field, value, isDxFormValid, additionalData)
    }

    renderForm = () => {
        const { fields } = this.props.workflowItem;

        const editorFormConfig = {
            fields: []
        };
        if (fields.Subject.visible) {
            editorFormConfig.fields.push({ label: fields.Subject.label, dataField: 'assistancetestserchdefect', required: true });
        }
        if (fields.Type.visible) {
            editorFormConfig.fields.push({ label: fields.Type.label, dataField: 'replycomment', required: true, editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display' } });
        }

        if (this.props.workflowItem.replyEnabled && fields.ResponseRequiredDate.visible) {
            if (this.state.selectedClause?.noReply) {
                //Do not show Response Required Date field
            } else if (this.state.selectedClause?.applyReplyPeriod && this.state.selectedClause.hasOwnProperty("replyPeriod")) {
                const replyrequireddate = moment(addDays(new Date(), this.state.selectedClause.replyPeriod)).toDate();
                editorFormConfig.fields.push({ label: fields.ResponseRequiredDate.label, dataField: 'replyrequireddate', editorType: 'dxDateBox', editorOptions: { readOnly: true, value: replyrequireddate } })
            }
            else if (this.props.workflowItem.replyPeriodOption === "ASKED_ON_COMMUNICATION_FORM") {
                editorFormConfig.fields.push({ label: fields.ResponseRequiredDate.label, dataField: 'replyrequireddate', editorType: 'dxDateBox', editorOptions: { calendarOptions: { min: new Date() }, max: addYears(new Date(), 10) }, validation: { type: 'range', min: moment().subtract(1, 'days'), max: addYears(new Date(), 10), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } });
            } else {
                const replyrequireddate = moment(addDays(new Date(), this.props.workflowItem.replyPeriod)).toDate();
                editorFormConfig.fields.push({ label: fields.ResponseRequiredDate.label, dataField: 'replyrequireddate', editorType: 'dxDateBox', editorOptions: { readOnly: true, value: replyrequireddate } })
            }
        }
        if (fields.Details.visible) {
            editorFormConfig.fields.push({ label: fields.Details.label, dataField: 'inspectiondetails', editorType: 'dxHtmlEditor' });
        }

        return (
            <BiDynamicForm
                item={this.props.notification}
                config={editorFormConfig}
                valueChangeHandler={this.fieldChanged}
                customFields={(this.props.customFields || {}).COMMUNICATION}
                assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
            />

        );
    }

    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.inspectiondefectid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }

    render() {
        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;
        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />

                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    contract={this.props.contract}
                    workflowItem={this.props.workflowItem}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );
    }
}

export default withSnackbar(injectIntl(NotifyDocumentPage));
